const isMobile = () => innerWidth <= 1024

export function initHeader() {
    initScrolledMenu()
    initHamburgerMenu()

    initSearchButton()
    initUserButton()
}

function initHamburgerMenu() {
    let timeout = null
    const hamburger = document.querySelector('#hamburger')
    const header = document.querySelector('header')

    hamburger.addEventListener('click', () => {
        clearTimeout(timeout)
        header.classList.toggle('open')

        if (!header.classList.contains('open')) {
            timeout = setTimeout(() => {
                header.classList.remove('visible')
            }, 1000)
            document.body.classList.remove('noscroll')
        }
        else {
            header.classList.add('visible')
            document.body.classList.add('noscroll')
        }
    })
}

function initSearchButton() {
    const searchButton = document.querySelector('header #search-button')
    const input = searchButton.querySelector('input[type=text]')

    searchButton.addEventListener('click', (event) => {
        event.preventDefault()

        if (event.target != input) {
            searchButton.classList.toggle('active')
            if (searchButton.classList.contains('active')) {
                input.focus()
            }
        }
    })
}

function initUserButton() {
    let timeout = null
    const userButton = document.querySelector('header #user-button')

    userButton.addEventListener('click', (event) => {
        const target = event.target
        const tagName = target.tagName
        
        const classList = userButton.classList

        if (isMobile()) {
            event.preventDefault()
            target.classList.contains('exit') ? classList.remove('active') : classList.add('active')

            if (!userButton.classList.contains('active')) {
                timeout = setTimeout(() => {
                    userButton.classList.remove('visible')
                }, 1000)
            } else {
                userButton.classList.add('visible')
            }
        } else if (tagName != 'INPUT' && tagName != 'A' && tagName != 'BUTTON') {
            event.preventDefault()
            userButton.classList.toggle('active')
        }
    })

    initHeaderButtonLeave()
}

function initHeaderButtonLeave() {
    const parent = document.querySelector('header .trailing-content')
    document.addEventListener('click', (event) => {
        if (!parent.contains(event.target)) {
            const actives = [...document.querySelectorAll('header div.trailing-content .active')]

            for (let i = 0; i < actives.length; i++) {
                actives[i].classList.remove('active')
            }
        }
    })
}

function initScrolledMenu() {
    const header = document.querySelector('header')
    const itemsWithChildren = header.querySelectorAll('nav ul#main-nav li.has-children')
    const height = header.offsetHeight
    const classList = header.classList

    document.addEventListener('scroll', (event) => {
        if (!isMobile()) {
            if (window.scrollY >= height) {
                classList.add('scrolled')
            } else if (classList.contains('scrolled')) {
                classList.add('slide-out')
                setTimeout(() => {
                    classList.remove('slide-out')
                    classList.remove('scrolled')
                    classList.add('fade-in')
                    setTimeout(() => classList.remove('fade-in'), 200)
                }, 200)
            }
        } else if (classList.contains('scrolled')) { // for when someone resizes to mobile.
            classList.remove('scrolled')
        }
    })


    for (let i = 0; i < itemsWithChildren.length; i++) {
        itemsWithChildren[i].addEventListener('mouseenter', (event) => handleMenuItem(event, true))
        itemsWithChildren[i].addEventListener('mouseleave', (event) => handleMenuItem(event, false))
    }

    const handleMenuItem = (event, enter) => {
        if (enter) {
            const children = event.target.querySelector('div.children')
            header.style.height = `${children.offsetHeight + 50}px`
        } else {
            header.removeAttribute('style')
        }
    }
}